var ref;
const getBundleItemProps = (bundledProduct, currency, title, priceIsZeroLabel)=>{
    var ref4, ref1, ref2, ref3;
    return {
        currency,
        title,
        body: bundledProduct.title,
        priceIsZeroLabel,
        originalPrice: (ref = (ref4 = bundledProduct.price) === null || ref4 === void 0 ? void 0 : ref4.original) !== null && ref !== void 0 ? ref : 0,
        discountedPrice: ((ref1 = bundledProduct.price) === null || ref1 === void 0 ? void 0 : ref1.discount) ? (ref2 = bundledProduct.price) === null || ref2 === void 0 ? void 0 : ref2.gross : undefined,
        discountText: (ref3 = bundledProduct.discount) === null || ref3 === void 0 ? void 0 : ref3.description
    };
};

export { getBundleItemProps };
//# sourceMappingURL=get-bundle-item-props.js.map
